import { TableRow } from '@/components/ui/table';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export const SortableItemRow = ({ id, children, readOnly }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id, disabled: readOnly });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : 1,
    background: isDragging ? 'rgba(45,148,140,0.06)' : undefined,
  };
  return (
    <TableRow
      ref={setNodeRef}
      style={style}
      {...attributes}
      className={`group hover:bg-[#2d948c]/[0.03] transition-colors ${isDragging ? 'shadow-md' : ''}`}
      data-testid={`item-row-${id}`}
    >
      {children(listeners)}
    </TableRow>
  );
};
